import React from 'react';
import { useRouter } from 'next/router';
import Layout from '@common/layout';
import Header from '@common/header';
import Content from '@common/content';
import Footer from '@common/footer';
import { InfoDetailCustomHead } from '@components/common/customHead';
import NoAffiliateAuthWrap from '@components/common/modals/affiliateModal/noAffiliateAuthWrap';
import NoMatchingUserModal from '@components/common/modals/affiliateModal/noMatcingUserModal';
import { useInfoDetail } from '@repository/post/usePost';
import InfoDetail from '../../components/info/detail';
import { ContentRouteUtil } from '@utils/routeUtil';
import useModals from '@utils/hooks/useModals';

const InfoDetailPage = () => {
  const { openModal, isVisible } = useModals(['noPartnerShip', 'noMatching']);
  const { query } = useRouter();
  const { sn: infoSn } = query;

  const handleError = (error: any) => {
    const errorCode = error.response?.data?.errorCode;
    switch (errorCode) {
      case 'B002':
      case 'B901':
        ContentRouteUtil.go404();
        break;
      case 'B902':
        ContentRouteUtil.goLoginPage();
        break;
      case 'B903':
        openModal('noPartnerShip');
        break;
      case 'B904':
        openModal('noMatching');
        break;
      default:
        break;
    }
  };

  const { data: detailData, isFetched } = useInfoDetail(Number(infoSn), {
    enabled: !!infoSn,
    onError: handleError,
  });

  if (!isFetched) return null;

  if (isVisible('noMatching'))
    return (
      <Layout>
        <Header />
        <NoMatchingUserModal visible={true} />
      </Layout>
    );

  if (isVisible('noPartnerShip')) return <NoAffiliateAuthWrap title="제휴서비스 인증이 필요해요" />;

  return (
    <Layout>
      <Header />
      <InfoDetailCustomHead title={detailData?.title ?? '취업 콘텐츠'} sn={detailData?.sn ?? 0} />
      <Content>
        <InfoDetail detailData={detailData} />
      </Content>
      <Footer />
    </Layout>
  );
};

export default InfoDetailPage;
